
<svg xmlns="http://www.w3.org/2000/svg" class="d-none">
  <symbol id="check2" viewBox="0 0 16 16">
    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
  </symbol>
  <symbol id="circle-half" viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"/>
  </symbol>
  <symbol id="moon-stars-fill" viewBox="0 0 16 16">
    <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"/>
    <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"/>
  </symbol>
  <symbol id="sun-fill" viewBox="0 0 16 16">
    <path d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/>
  </symbol>
  <symbol id="check" viewBox="0 0 16 16">
    <title>Check</title>
    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
  </symbol>
</svg>

<!-- ntrip-caster-section -->
<div id="ntrip-caster-section" class="container col-xxl-8 px-4" style="scroll-margin-top: 72px;">
  <div class="row flex-lg-row-reverse align-items-center g-5 py-3">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="assets/images/landing/GeoAstra_NTRIP.png" class="d-block mx-lg-auto img-fluid lnc-zoom-img ntrip-hero-img" alt="GeoAstra NTRIP" width="700" height="500" loading="lazy"
           (click)="openLightbox('assets/images/landing/GeoAstra_NTRIP.png','GeoAstra NTRIP')">
    </div>
    <div class="col-lg-6">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">GeoAstra NTRIP Caster</h1>
      <h2 class="display-5 lh-1 mb-3">Transform Your RTK Base into Your Own CORS Service</h2>
      <ul>
        <li><strong>Free</strong> — but commercial-grade</li>
        <li>Worldwide coverage</li>
        <li>Compatible with all RTK bases and rovers</li>
        <li>Supports both permanent and portable RTK base stations</li>
        <li>One RTK base serving multiple rovers</li>
        <li>Unlimited baseline distance — no radio required</li>
        <li>Real-time NTRIP connection monitoring</li>
      </ul>
      <div class="d-grid gap-2 d-md-flex justify-content-md-start">
        <button type="button" class="btn btn-outline-secondary btn-lg px-4" (click)="login()">Login</button>
        <button type="button" class="btn btn-primary btn-lg px-4 me-md-2" (click)="signup()">Sign-up</button>
      </div>
    </div>
  </div>
</div>

<!-- how-ntrip-caster-works-section -->
<div id="how-ntrip-caster-works-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="row py-2">
    <div class="col-12">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">How GeoAstra NTRIP Caster Works</h1>
    </div>
  </div>
  <div class="row py-2">
    <div class="col-12">
      <img
        src="assets/images/landing/GeoAstra_Ntrip_caster_data_flow_diagram.png"
        class="img-fluid w-100 lnc-zoom-img ntrip-dataflow"
        alt="How GeoAstra NTRIP Caster Works"
        loading="lazy"
        (click)="openLightbox('assets/images/landing/GeoAstra_Ntrip_caster_data_flow_diagram.png','How GeoAstra NTRIP Caster Works')"
      >
    </div>
  </div>
</div>

<!-- pricing-section -->
<div id="pricing-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="container py-3">    
    <main>
      <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
        <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Pricing</h1>      
      </div>
      <div class="row g-3 mb-3 text-center align-items-stretch">
        <div class="col-12 col-md-6 col-lg-3 d-flex">
          <div class="card rounded-3 shadow-sm w-100 h-100 d-flex flex-column">
            <div class="card-header py-3">
              <h4 class="my-0 fw-normal">Free</h4>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              <h1 class="card-title pricing-card-title">$0<small class="text-body-secondary fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>Mount points: 1</li>
                <li>Rovers: 2</li>
                <li>Source table</li>
                <li>Live monitor</li>
                <li>Shared server</li>
                <li>Forum support</li>
              </ul>
              <button type="button" class="mt-auto w-100 btn btn-lg btn-outline-primary" (click)="login()">Sign up</button>
            </div>
          </div>
        </div>
        <!-- Basic plan (inserted) -->
        <div class="col-12 col-md-6 col-lg-3 d-flex">
          <div class="card rounded-3 shadow-sm w-100 h-100 d-flex flex-column">
            <div class="card-header py-3">
              <h4 class="my-0 fw-normal">Basic</h4>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              <h1 class="card-title pricing-card-title">$39<small class="text-body-secondary fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>Mount points: 1</li>
                <li>Rovers: 5</li>
                <li>Source table</li>
                <li>Live monitor</li>
                <li>Shared server</li>
                <li>Forum support</li>
                <li>Email support</li>
                <li>RTK Base Analyzer</li>
                <li>PPK Downloader</li>
              </ul>
              <button type="button" class="mt-auto w-100 btn btn-lg btn-primary" (click)="redirectToBasic()">Order Now</button>
            </div>
          </div>
        </div>

        <!-- Pro plan (moved to third column) -->
        <div class="col-12 col-md-6 col-lg-3 d-flex">
          <div class="card rounded-3 shadow-sm w-100 h-100 d-flex flex-column">
            <div class="card-header py-3">
              <h4 class="my-0 fw-normal">Pro</h4>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              <h1 class="card-title pricing-card-title">$99<small class="text-body-secondary fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>Mount points: 10</li>
                <li>Rovers: 100</li>
                <li>Source table</li>
                <li>Live monitor</li>
                <li>Shared server</li>
                <li>Forum support</li>
                <li>Email support</li>
                <li>RTK Base Analyzer</li>
                <li>PPK Downloader</li>
              </ul>
              <button type="button" class="mt-auto w-100 btn btn-lg btn-primary" (click)="redirectToPro()">Order Now</button>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 d-flex">
          <div class="card rounded-3 shadow-sm w-100 h-100 d-flex flex-column">
            <div class="card-header py-3">
              <h4 class="my-0 fw-normal">Enterprise</h4>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              <h1 class="card-title pricing-card-title">$399<small class="text-body-secondary fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>Mount points: 50</li>
                <li>Rovers: 1,000</li>
                <li>Source table</li>
                <li>Live monitor</li>
                <li>Dedicated server</li>
                <li>Forum support</li>
                <li>Email support</li>
                <li>RTK Base Analyzer</li>
                <li>PPK Downloader</li>
                <li>Custom domain</li>
                <li>Custom branding settings</li>
                <li>Public access settings</li>
                <li>Web management console</li>
              </ul>
              <button type="button" class="mt-auto w-100 btn btn-lg btn-primary" (click)="redirectToEnterPrise()">Order Now</button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <br>
    <p >We offer software customization and integration services. Please email <a href="mailto:info@geoastra.com">info&#64;geoastra.com</a> to discuss your needs.</p>
  </div>
</div>

<!-- compare-plans-section -->
<div id="compare-plans-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="container py-3">    
    <main>
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3 text-center">Compare Plans</h1>
  
      <div class="table-responsive">
        <table class="table text-center">
          <thead>
            <tr>
              <th style="width: 34%;"></th>
              <th style="width: 16%;">Free</th>
              <th style="width: 16%;">Basic</th>
              <th style="width: 16%;">Pro</th>
              <th style="width: 16%;">Enterprise</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row" class="text-start">Base Stations / Mount Points</th>
              <td>1</td>
              <td>1</td>
              <td>10</td>
              <td>50</td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Rovers</th>
              <td>2</td>
              <td>5</td>
              <td>100</td>
              <td>1000</td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Ntrip Source Table</th>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Share Server</th>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Forum Support</th>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Email Support</th>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>

            <!-- Newly added feature rows -->
            <tr>
              <th scope="row" class="text-start">Live Ntrip connections monitor</th>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">RTK Base Analyzer</th>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">PPK Downloader</th>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>

            <tr>
              <th scope="row" class="text-start">Custom Domain</th>
              <td></td>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Custom branding settings</th>
              <td></td>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Public access settings</th>
              <td></td>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Connection Log</th>
              <td></td>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Web Management Console</th>
              <td></td>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <!-- Moved: Dedicate Server row now below Email Support -->
            <tr>
              <th scope="row" class="text-start">Dedicate Server</th>
              <td></td>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  </div>
</div>

<!-- Additional Resources Section -->
<div id="resources-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="container py-3">
    <main>
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3 text-center">Learn More</h1>
      <div class="row g-3">
        <div class="col-12 col-md-6 d-flex">
          <div class="card w-100 h-100 d-flex flex-column shadow-sm rounded-3">
            <div class="card-body d-flex flex-column justify-content-center">
              <h3 class="card-title mb-3 fw-bold">What's New in Version 2.0</h3>
              <ul class="card-text list-unstyled mb-3 text-start">
                <li><a (click)="goToWhatsNewAnchor('live-monitor')" class="text-decoration-none">• Live NTRIP Connections Monitor</a></li>
                <li><a (click)="goToWhatsNewAnchor('visualize-data')" class="text-decoration-none">• Visualize Mountpoint & RTK Base Data</a></li>
                <li><a (click)="goToWhatsNewAnchor('rtk-analyzer')" class="text-decoration-none">• RTK Base Analyzer</a></li>
                <li><a (click)="goToWhatsNewAnchor('ppk-downloader')" class="text-decoration-none">• PPK Downloader</a></li>
              </ul>
              <button type="button" class="mt-auto btn btn-primary" (click)="goToWhatsNewTop()">Learn More</button>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 d-flex">
          <div class="card w-100 h-100 d-flex flex-column shadow-sm rounded-3">
            <div class="card-body d-flex flex-column justify-content-center">
              <h3 class="card-title mb-3 fw-bold">Quick Start / User Guide</h3>
              <ul class="card-text list-unstyled mb-3 text-start">
                <li><a (click)="goToQuickStartAnchor('intro-service')" class="text-decoration-none">• Introducing GeoAstra NTRIP Service</a></li>
                <li><a (click)="goToQuickStartAnchor('signup-login')" class="text-decoration-none">• Sign-up & Login Options</a></li>
                <li><a (click)="goToQuickStartAnchor('after-login')" class="text-decoration-none">• Getting Started After Login</a></li>
                <li><a (click)="goToQuickStartAnchor('configure-rtk')" class="text-decoration-none">• Configure RTK Bases & Rovers</a></li>
              </ul>
              <button type="button" class="mt-auto btn btn-primary" (click)="goToQuickStartTop()">Learn More</button>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>

<!-- stores-section -->
<div id="stores-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 72px;">
  <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
    <div class="col-10 col-sm-8 col-lg-6">
      <img src="assets/images/landing/stores.png" class="d-block mx-lg-auto img-fluid lnc-zoom-img" alt="RTK GNSS Stores" width="700" height="500" loading="lazy"
           (click)="openLightbox('assets/images/landing/stores.png','RTK GNSS Stores')">
    </div>
    <div class="col-lg-6">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">RTK GNSS Stores</h1>
      <p>Are you looking to buy RTK devices?</p>
      <br>
      <h3>RTK Base</h3>
      <ul>
        <li>Looking for a cost-effective RTK base starting as low as US$249?</li>
        <li>In need of a commercial-grade fixed RTK base?</li>
        <li>Searching for a portable RTK base that doesn't require a fixed location and can be used on the go?</li>
        <li>Considering a dual-band or triple-band RTK base?</li>      
      </ul>
      <br>
      <h3>RTK Rover</h3>
      <ul>
        <li>Seeking low-cost RTK GNSS receivers for large-scale deployments?</li>
        <li>Need an RTK GNSS compatible with your iPhone, Android phone, or Windows computer?</li>
        <li>Looking for a GNSS data logger?</li>
        <li>Searching for a GNSS module for your project?</li>      
      </ul>  
      <br>
      <h3>End-to-End RTK Solutions</h3>
      <ul>
        <li>Require a comprehensive RTK solution for high accuracy, including Base, NTRIP Caster, and Rover?</li>
        <li>Looking for end-to-end RTK data logger solutions?</li>   
      </ul> 
      <p>We believe the key to expanding the practical use of RTK solutions lies in affordability and ease of use. The products offered by the following webshops align with this philosophy, providing a wide range of RTK products to meet your needs. Check them out at</p> 
 
       <br>
      <p><a href="https://gpswebshop.com" target="_blank" rel="noopener">GPSWebShop Online Store</a></p>
      <p><a href="https://canadagps.ca" target="_blank" rel="noopener">CanadaGPS Online Store</a></p>

      <!-- Store buttons moved from header -->
      <div class="store-buttons mt-3">
        <a class="store-cta me-2" href="https://canadagps.ca/" target="_blank" rel="noopener" aria-label="Open Canada Store">
          <img src="assets/images/landing/Canada-SVG.svg" alt="Canada" class="ca-flag-img" />
          <span class="store-label">STORE</span>
        </a>
        <a class="store-cta" href="https://gpswebshop.com/" target="_blank" rel="noopener" aria-label="Open Global Store">
          <span class="material-icons icon icon-earth" style="color: #3b82f6;">language</span>
          <span class="store-label">STORE</span>
        </a>
      </div>

    </div>
  </div>
</div>

<!-- Lightbox overlay -->
<div *ngIf="lightboxOpen" class="lightbox-backdrop" (click)="closeLightbox()">
  <div class="lightbox-content" (click)="$event.stopPropagation()">
    <button type="button" class="btn-close lightbox-close" aria-label="Close" (click)="closeLightbox()"></button>
    <img [src]="lightboxSrc" [alt]="lightboxAlt" class="img-fluid w-100" />
  </div>
</div>
